<template>
  <div class="w1200 create">
      <div class="mtitle2 cen">请选择设计类型和研究疾病</div>
      <el-cascader @change="treechange" 
    placeholder="请搜索疾病名称" :props="{ children: 'child',label:'name',value:'id' }"
    :options="treelist" 
    filterable></el-cascader>
       
        <el-row :gutter="20">
            <el-col :span="6">
                 <el-select class="sel" v-model="form.yjsjlx_id" placeholder="请选择设计类型">
                    <el-option
                    v-for="item in sjlxlist"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                    </el-option>
                </el-select>
            </el-col>
            <el-col :span="6">
                 <el-select class="sel" v-model="sort1" placeholder="请选择疾病一级分类">
                    <el-option
                    v-for="item in treelist"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                    </el-option>
                </el-select>
            </el-col>
            <el-col :span="6">
                 <el-select class="sel" v-model="sort2" placeholder="请选择疾病二级分类">
                    <el-option
                    v-for="item in findarry(treelist,sort1)"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                    </el-option>
                </el-select>
            </el-col>
            <el-col :span="6">
                 <el-select class="sel" v-model="sort3" placeholder="请选择具体疾病">
                    <el-option
                    v-for="item in findarry(findarry(treelist,sort1),sort2)"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                    </el-option>
                </el-select>
            </el-col>
            <el-col :span="6" v-if="sort3!=''&&findarry(findarry(findarry(treelist,sort1),sort2),sort3)&&(findarry(findarry(findarry(treelist,sort1),sort2),sort3)).length>0">
                 <el-select class="sel" v-model="sort4" placeholder="请选择具体疾病">
                    <el-option
                    v-for="item in findarry(findarry(findarry(treelist,sort1),sort2),sort3)"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                    </el-option>
                </el-select>
            </el-col>
            <el-col :span="6" v-if="sort4!=''&&findarry(findarry(findarry(findarry(treelist,sort1),sort2),sort3),sort4)&&(findarry(findarry(findarry(findarry(treelist,sort1),sort2),sort3),sort4)).length>0">
                 <el-select class="sel" v-model="sort5" placeholder="请选择具体疾病">
                    <el-option
                    v-for="item in findarry(findarry(findarry(findarry(treelist,sort1),sort2),sort3),sort4)"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                    </el-option>
                </el-select>
            </el-col>
            <el-col :span="6" v-if="sort5!=''&&findarry(findarry(findarry(findarry(findarry(treelist,sort1),sort2),sort3),sort4),sort5)&&(findarry(findarry(findarry(findarry(findarry(treelist,sort1),sort2),sort3),sort4),sort5)).length>0">
                 <el-select class="sel" v-model="sort6" placeholder="请选择具体疾病">
                    <el-option
                    v-for="item in findarry(findarry(findarry(findarry(findarry(treelist,sort1),sort2),sort3),sort4),sort5)"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                    </el-option>
                </el-select>
            </el-col>
        </el-row>
        <el-button type="primary" class="xyb" @click="send">下一步</el-button>
  </div>
</template>

<script>
import { getYjsjlxList,getBzflListTree } from "@/api/index.js"
export default {
  data() {
    return {
       selectedOptions: [], 
       options: [{
          value: '选项1',
          label: '黄金糕'
        }, {
          value: '选项2',
          label: '双皮奶'
        }, {
          value: '选项3',
          label: '蚵仔煎'
        }, {
          value: '选项4',
          label: '龙须面'
        }, {
          value: '选项5',
          label: '北京烤鸭'
        }],
        form:{
            yjsjlx_id:'',
            bzfl_id:''
        },
        sjlxlist:[],
        treelist:[],
        sort1:'',
        sort2:'',
        sort3:'',
        sort4:'',
        sort5:'',
        sort6:''
    }
  },
   mounted() {
      getYjsjlxList().then(res=>{
        if(res.code==1){
          this.sjlxlist=res.data.rows
        }
      })
      getBzflListTree().then(res=>{
        if(res.code==1){
           this.treelist=this.removeEmptyChildren(res.data)
        }
      })
    },
  methods:{
    send(){
      if(this.form.yjsjlx_id==''){
         this.$message.error('请选择设计类型');
        return
      }
      this.form.bzfl_id=this.sort3
      if(this.sort4!=''){
        this.form.bzfl_id=this.sort4
      }
      if(this.sort5!=''){
        this.form.bzfl_id=this.sort5
      }
      if(this.sort6!=''){
        this.form.bzfl_id=this.sort6
      }
       this.$router.push('/create2?yjsjlx_id='+this.form.yjsjlx_id+'&bzfl_id='+this.form.bzfl_id)
    },
    findarry(list,sort){
      if(list&&list.length>0&&sort!=''){
         return list.filter(item=>item.id==sort)[0].child
      }else{
        return []
      }
     
    },
     removeEmptyChildren(tree) {
  if (!tree || typeof tree !== 'object') return tree;
  
  if (Array.isArray(tree)) {
    return tree.map(item => this.removeEmptyChildren(item)).filter(item => item !== null);
  }
  
  const newNode = { ...tree };
  
  // 如果有child属性且是数组
  if (newNode.hasOwnProperty('child') && Array.isArray(newNode.child)) {
    // 递归处理子节点
    newNode.child = this.removeEmptyChildren(newNode.child);
    
    // 如果处理后的child为空数组，则删除child属性
    if (newNode.child.length === 0) {
      delete newNode.child;
    }
  }
  
  // 处理其他可能包含子节点的属性
  Object.keys(newNode).forEach(key => {
    if (key !== 'child' && typeof newNode[key] === 'object' && newNode[key] !== null) {
      newNode[key] = this.removeEmptyChildren(newNode[key]);
    }
  });
  
  return newNode;
},
    treechange(e){
      this.selectedOptions=e
      this.form.bzfl_id=e[e.length-1]
      this.sort1=e[0]
      if(e.length>1){
        this.sort2=e[1]
      }
      if(e.length>2){
         this.sort3=e[2]
      }
      if(e.length>3){
         this.sort4=e[3]
      }
      if(e.length>4){
         this.sort5=e[4]
      }
       if(e.length>5){
         this.sort6=e[5]
      }
     
    }
  }
};
</script>

<style lang="less">
.create {
   height: calc(100vh - 130px);display:flex; flex-direction: column;justify-content: center;
   .sel {width:100%;margin-bottom: 20px;}
   .el-cascader {display:block!important;margin:80px 0px 30px 0px;
        .el-input {
          position: relative;
          &::after {
              content:"\e778";font-size: 30px;position: absolute;left:20px;top:7px;color:#AFAFAF;font-family: element-icons !important;
            }
        }
        .el-input__suffix {display: none}
        .el-input__inner {
            height:55px;font-size:22px;padding-left:60px;position: relative;
            
        }
        
       
    }

    .xyb {margin:80px auto;background:#2397CA;font-size:20px;width:300px;height:50px;display: block}
}
</style>
